/* Barrel — imports all domain CSS files in dependency order.
   Vite resolves @import at build time (zero runtime cost). */

/* Foundation */
@import "./tokens.css";
@import "./base.css";

/* Shell */
@import "./shell.css";
@import "./hamburger.css";

/* Shared UI */
@import "./builder-header.css";
@import "./dialog.css";
@import "./toast.css";
@import "./breadcrumbs.css";
@import "./skeleton.css";
@import "./empty-state.css";
@import "./badges.css";
@import "./inline-menu.css";
@import "./build-badge.css";

/* Pages */
@import "./home.css";
@import "./template-list.css";
@import "./evaluations.css";

/* Editor */
@import "./editor.css";
@import "./unified-editor.css";
@import "./unified-controls.css";
@import "./tiptap-nodes.css";

/* Filler */
@import "./filler.css";
@import "./filler-fields.css";
@import "./filler-controls.css";
@import "./filler-layout.css";

/* Report & Print */
@import "./report.css";
